// src/auth/RequireAuth.jsx
import React, { useEffect } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireAuth() {
  const { user, accessToken, primaryRestaurantId, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;

    // if session is invalid in any of these ways → go to login
    if (!user || !accessToken || !primaryRestaurantId) {
      navigate("/login", {
        replace: true,
        state: { from: location },
      });
    }
  }, [user, accessToken, primaryRestaurantId, loading, navigate, location]);

  if (loading) {
    return <div>Loading session…</div>;
  }

  if (!user || !accessToken || !primaryRestaurantId) {
    // We already triggered navigate; render nothing while redirecting
    return null;
  }

  // All good → render the protected routes
  return <Outlet />;
}
